import { render, staticRenderFns } from "./MarketplaceVehicleManager.vue?vue&type=template&id=1c87a90f"
import script from "./MarketplaceVehicleManager.vue?vue&type=script&lang=js"
export * from "./MarketplaceVehicleManager.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports